var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list-item-title',{staticClass:"text-center"},[_vm._v(" "+_vm._s(!_vm.getClientName ? "PCM Soluções" : ("" + _vm.getClientName))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }